import { Container, Row, Col } from "react-bootstrap";

const Impact = () => {
  return (
    <div className=" py-4">
      <Container>
        <Row className="text-center">
          <Col>
            <h2>1000+</h2>
            <p>Legal Professionals</p>
          </Col>
          <Col>
            <h2>25+</h2>
            <p>National Programs</p>
          </Col>
          <Col>
            <h2>150+</h2>
            <p>Youth Initiatives</p>
          </Col>
          <Col>
            <h2>20+</h2>
            <p>States Reached</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Impact;
